<template>
  <div class="ticket-detail-content-wrapper">
    <div v-if="!value.ticket" class="skeleton-wrapper">
      <van-skeleton :row="5" title />
    </div>
    <div v-else>
      <van-panel>
        <template #header>
          <van-notice-bar color="#1989fa" background="#ecf9ff" style="fontSize:20px">
            {{ value.ticket }}&nbsp;&nbsp;&nbsp;
            <van-tag round type="primary">{{ value.ticketType.type }}</van-tag>
          </van-notice-bar>
        </template>

        <display-field
          label="价格"
          :value="`￥${value.display_price || value.price || 0}`"
          highlight
        />

        <field-option-tel-input
          v-if="value.message_mobile !== 0"
          @change="tel => handleFieldChange('tel', tel)"
        />

        <field-option-date-picker
          :date="value.can_book_time"
          @change="date => handleFieldChange('date', date)"
        />

        <field-option-reserve-picker
          v-if="reserves.length"
          :reserves="reserves"
          ref="reserve-picker"
          @change="reserve => handleFieldChange('reserve', reserve)"
        />

        <display-field
          label="库存"
          v-if="stock !== -1 && stock !== undefined"
          :value="stock ? String(stock) : '当前预约已满'"
          highlight
        />

        <field-option-count-input
          :left="stock"
          ref="count-input"
          :reserve="form.reserve"
          @change="count => handleFieldChange('count', count)"
        />
        <!-- 身份信息 -->
        <field-option-customer-info-group
          v-if="value.message_name !== 0 || value.message_idcard !== 0"
          :items="form.info"
          :sty="value.style"
          :name="value.message_name"
          :idcard="value.message_idcard"
          @change="info => handleFieldChange('info', info)"
        />
      </van-panel>
    </div>
  </div>
</template>
<script>
import DisplayField from '../../../components/DisplayField.vue';
import FieldOptionTelInput from '../../../components/FieldOptionTelInput.vue';
// import FieldOptionShopPicker from '../../../components/FieldOptionShopPicker.vue';
import FieldOptionDatePicker from '../../../components/FieldOptionDatePicker.vue';
import FieldOptionReservePicker from '../../../components/FieldOptionReservePicker.vue';
import FieldOptionCountInput from '../../../components/FieldOptionCountInput';
import FieldOptionCustomerInfoGroup from '../../../components/FieldOptionCustomerInfoGroup.vue';

export default {
  components: {
    DisplayField,
    FieldOptionTelInput,
    // FieldOptionShopPicker,
    FieldOptionDatePicker,
    FieldOptionReservePicker,
    FieldOptionCountInput,
    FieldOptionCustomerInfoGroup,
  },
  props: {
    value: [Object],
    united: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      arr: [],
      form: {
        tel: '',
        date: '',
        reserve: '',
        shop: '',
        count: 0,
        info: [],
      },
      reserves: [],
      left: undefined,
    };
  },
  computed: {
    stock() {
      return this.left;
    },
  },
  methods: {
    handleFieldChange(key, value) {
      let { info } = this.form;
      let val = value;
      if (key === 'date') {
        this.left = val.count;
        this.form.price = val.price;
        this.reserves = val.reserve;
        val = val.date;
        if (this.$refs['count-input']) this.$refs['count-input'].resetCount();
        if (this.$refs['reserve-picker']) this.$refs['reserve-picker'].resetReserve();
      }
      if (key === 'reserve') {
        this.left = val.count;
        this.form.price = val.price;
        if (this.$refs['count-input']) this.$refs['count-input'].resetCount();
      }
      if (key === 'count') {
        if (this.left !== -1 && val < info.length) {
          info = info.slice(0, val);
        } else {
          info = [
            ...info,
            ...Array.from({ length: val - info.length }, () => ({
              name: '',
              identityNo: '',
              discountCardNo: '',
            })),
          ];
        }
      }
      this.form = { ...this.form, info, [key]: val };
      this.$emit('change', this.form);
    },
  },
};
</script>
<style lang="less" scoped>
.ticket-detail-content-wrapper {
  // padding-right: 16px;
  .skeleton-wrapper {
    padding-top: 16px;
  }
  .van-hairline--top-bottom::after {
    border-bottom: none;
  }
  .van-panel__header .van-cell__title {
    padding: 4px 0;
    font-size: 140%;
  }
  .absolute-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
    height: 100%;
    background: #fff;
  }
}
</style>
